/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable prefer-const */
// 1- regenerate_url
// 2- base_api_url
// 3- base_portal_url
// base_portal_url + regenerate_url
import { JSEncrypt } from "jsencrypt";
import SpecificExceptions from "./specific-exceptions";
import GenericExceptions from "./generic-exceptions";

const win: any = window;
// win['base_api_url']="http://sdea003:9080/api/";
// win["clientToken"]="fNbD0BW88tiSCJC3FFbRzBnTuWHF"
const base_portal_url = win["base_portal_url"];
const CEM_KEY = win["CEM_KEY"];

export async function callBackendService(
  url: string,
  methodType: any,
  requestBody?: any,
  token?: string
) {
  let headers = {
    "Content-Type": "application/json",
    "cem-key": CEM_KEY,
  };

  let extraHeader = { Authorization: "Bearer " + token };

  if (extraHeader) {
    headers = { ...headers, ...extraHeader };
  }

  console.log("callBackendService :: Headers => " + JSON.stringify(headers));

  return new Promise((resolve, reject) => {
    let baseURL = win["base_api_url"]
      ? win["base_api_url"]
      : "http://sdea003:9080/api/";
    // let corsHack = "https://cors-anywhere.herokuapp.com/";
    let req;

    if (!!requestBody) {
      req = fetch(baseURL + url, {
        method: methodType,
        body: JSON.stringify(requestBody),
        headers: headers,
      });
    } else {
      req = fetch(baseURL + url, {
        method: methodType,
        headers: headers,
      });
    }
    console.log(baseURL + url, {
      method: methodType,
      headers: headers,
    });
    req
      .then(async (res) => res.json())
      .then(async (result) => {
        console.log("BackEnd :: Result => " + JSON.stringify(result));
        if (result.statusCode && result.statusCode === "MBE_323") {
          let newtoken: any = await regenerate_url();
          resolve(
            await callBackendService(url, methodType, requestBody, newtoken)
          );
        } else if (result.code && result.code !== "MAPI-000") {
          if (result.code === "MAPI-500") {
            console.log("BackEnd :: Result :: GenericExceptions");
            reject(new GenericExceptions(result.englishDetail));
          } else {
            console.log("BackEnd :: Result :: SpecificExceptions");

            if (win["lang"] === "en") {
              // ENGLISH LANGUAGE
              reject(new SpecificExceptions(result.code, result.englishDetail));
            } else {
              // ARABIC LANGUAGE
              reject(new SpecificExceptions(result.code, result.arabicDetail));
            }
          }
        }
        console.log("BackEnd :: Result  after=> " + JSON.stringify(result));
        resolve(result);
      })
      .catch((err) => {
        reject(err);
        console.log("BackEnd :: catch => " + err);
        console.log(err);
      });
  });
}

export function encrypt(message: string) {
  console.log("encrypt :: Enter");

  console.log("encrypt :: param :: message => " + message);

  const publicKey = win["PK"];

  let RSAEncrypt = new JSEncrypt();

  RSAEncrypt.setPublicKey(publicKey);

  let encryptedMessage = RSAEncrypt.encrypt(message);

  console.log("encrypt :: encryptedMessage => " + encryptedMessage);

  return encryptedMessage;
}

export function regenerate_url() {
  console.log("regenerate_url :: Enter");
  let regenerate_url = win["regenerate_url"]
    ? base_portal_url + win["regenerate_url"]
    : "http://sdea003:9080/api/internal-oauth-server/oauth/token";

  console.log("regenerate_url => " + regenerate_url);

  return new Promise((resolve, reject) => {
    fetch(regenerate_url, {
      method: "GET",
      headers: {
        "Content-type": "text/html; charset=UTF-8",
      },
    })
      .then((res) => res.text())
      .then((result) => {
        console.log("Token res -> " + result);

        resolve(result);
      })
      .catch((err) => {
        console.log(err);

        reject(err);
      });
  });
}

export * from "./CarriersApi";
